import { Box, Stack } from "@mui/joy";
import { Outlet, createFileRoute } from "@tanstack/react-router";

import TaskSetOverview from "../../../components/TaskSetOverview/TaskSetOverview";
import { TaskSetProvider } from "../../../components/TaskSetOverview/useTaskSetOverview";
import { useTaskSetQuery } from "../../../hooks/tasks";

export const SetDetail = () => {
  const params = Route.useParams();

  const { data: taskSet } = useTaskSetQuery(params.setUuid);

  return (
    <TaskSetProvider taskSet={taskSet}>
      <Stack direction="row" sx={{ height: "100%" }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <TaskSetOverview />
        </Box>
        <Outlet />
      </Stack>
    </TaskSetProvider>
  );
};

export const Route = createFileRoute("/gym/$venueUuid/schedule/set/$setUuid")({
  component: SetDetail,
  beforeLoad: () => {
    return {
      switchVenueLinkOpts: {
        path: "/gym/$venueUuid/schedule",
      },
    };
  },
});
